<div class="d-flex align-items-center success">
    <div class="mat-body chip-content"><ng-content></ng-content></div>
    <vp-icon icon="check-default" class="vp-icon-success ms-3"></vp-icon>
</div>
